export const ADDED_TO_CART = 'added-to-cart'
export const ORDER_PLACED = 'order-placed'
export const BEGIN_CHECKOUT = 'begin-checkout'